import restAPI from '@/utils/rest-api'

export default {
    exists(vat) {
        return restAPI.get(`/existing-customers/exists/vat/${vat}`)
    }
}
